import GENERAL from './general';
import RANDOM_COLOR from './randomColor';
import WORK_WITH_DATE from './methodsForDate';
import WORK_WITH_STRING from './methodsForString';
import SORT_TABLE_DEFAULT from './sortTableDefault';

const helpers = {

  work_with_date: WORK_WITH_DATE,

  work_with_string: WORK_WITH_STRING,

  random_color: RANDOM_COLOR,

  sort_table_default: SORT_TABLE_DEFAULT,

  general: GENERAL,

};

export default helpers;
